import React, { useEffect, useState } from 'react';

import { Col, Row, Form, Input, Button, Select, Alert ,notification} from 'antd';

import ReactPixel from 'react-facebook-pixel';

import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";

import {
    CardElement, 
    useElements,
    useStripe
} from '@stripe/react-stripe-js';

const { Option } = Select;

const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
                color: '#aab7c4'
            }
        },
        invalid: {
            color: '#ff4d4f',
            iconColor: '#ff4d4f'
        }
    }
};

export const CheckoutForm = (props) => {
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const stripe = useStripe();
    const elements = useElements();
    const recaptchaRef = React.createRef();
    const [form] = Form.useForm();
    const [isSubscriberExist ,setIsSubscriberExist] = useState(false)
    useEffect(()=>{
        const subscriberInfo = props.subscriber;
        if(props.subscriber){
           form.setFieldsValue({
                phoneNumber: subscriberInfo.phoneNumber  ,
                firstName: subscriberInfo.firstName ,
                lastName:subscriberInfo.lastName ? subscriberInfo.lastName:'',
                businessName:subscriberInfo.businessName? subscriberInfo.businessName:'',
                addressOne:subscriberInfo.addressOne ? subscriberInfo.addressOne :'',
                addressTwo:subscriberInfo.addressTwo ? subscriberInfo.addressTwo :'',
                // addressTwo:'',
                city:subscriberInfo.city ? subscriberInfo.city:'',
                state:subscriberInfo.state ? subscriberInfo.state:'',
                zipCode:subscriberInfo.zipCode ? subscriberInfo.zipCode:''

              });
              setIsSubscriberExist(true)
        }
        
    },[]);

    const handleChange = (event) => {
        if (event.error) {
            setError(event.error.message);
        } else {
            setError(null);
        }
    };

    function captchaChange(value) {
        console.log("Captcha value:", value);
    }

    const handleSubmit = async customerInfo => {
        setSubmitting(true);
        if (!stripe || !elements) return;
        // recaptchaRef.current.execute();
        customerInfo.merchant = props.merchant.id;
        if(isSubscriberExist){
            console.log(" already exist !" ,customerInfo);
            const subscriber =  props.subscriber._id
            const data = {
                customer: props.subscriber?.stripe.customer.id,
                stripeAccount: props.merchant.stripeAccount
            }
            const url = `${props.apiUrl}/stripe/setupIntents/`;
            const response = await axios.post(url, data);
            const { clientSecret } = response.data;
            await subscriberStripeSetup(customerInfo , subscriber ,clientSecret);
        }else{
            console.log(" not exist !");
            const url = `${props.apiUrl}/subscriber/create/`;
            const response = await axios.post(url, customerInfo);
            const { subscriber, clientSecret } = response.data;
            if(subscriber && clientSecret){
                await subscriberStripeSetup(customerInfo , subscriber ,clientSecret);
            }else{
                notification.error({  message: response.data.message})
            }
        }

        
    };

const subscriberStripeSetup = async(customerInfo,subscriber,clientSecret)=>{
      try{
         const card = elements.getElement(CardElement);
       
         if(customerInfo && subscriber && clientSecret ){
            setSubmitting(true);
            const result = await stripe.confirmCardSetup(clientSecret, {
                payment_method: {
                    card,
                    billing_details: {
                        name: `${customerInfo.firstName} ${customerInfo.lastName}`,
                        address: {
                            city: customerInfo.city,
                            country: 'US',
                            line1: customerInfo.addressOne,
                            line2: customerInfo.addressTwo,
                            postal_code: customerInfo.zipCode,
                            state: customerInfo.state,
                        }
                    },
                }
            });
            
            if (result.error) {
                console.log(result.error);
                setError(result.error.message);
            } else {
                const paymentMethod = result.setupIntent.payment_method;
                const setPaymentUrl = `${props.apiUrl}/subscriber/payment/${subscriber}?paymentMethod=${paymentMethod}`;
    
                await axios.put(setPaymentUrl);
                ReactPixel.track(
                    'CompleteRegistration', {
                    value: 0.10,
                    currency: 'USD',
                    content_name: 'Signup',
                    status: 'complete'
                });
                setSuccess(true);
            }
    
            setSubmitting(false);
         }else{
            notification.error({  message: "data not found !"})
            setSubmitting(false)
            // return (<Alert message={response.data.message} type={"error"} />)
         }
      }catch(error){
        notification.error({  message: error.message})
      }
}


    return (
        success ?
            <Alert message={"You are successfully signed up!"} type={"success"} />
            :

            <Form
                form={form}
                layout={"vertical"}
                style={{ maxWidth: 1000, margin: 'auto', color: 'black !important;', fontFamily: props.fontFamily }}
                onFinishFailed={() => { }}
                onFinish={handleSubmit}
            >
                <Input.Group size="large">
                    <Form.Item
                        style={{ color: 'black' }}
                        name={"phoneNumber"}
                        label={"Cell phone number"}
                        rules={[{ required: true, message: 'Fill in your cell phone number.' }]}
                    >
                        <Input disabled={props.subscriber?.phoneNumber ? true:false} type="tel" prefix={"+1"} placeholder={"Cell phone number"} />
                    </Form.Item>
                </Input.Group>
                <h3>Where can we ship it to you?</h3>
                <Input.Group size="large">
                    <Row gutter={12}>
                        <Col span={12}>
                            <Form.Item
                                style={{ color: 'black' }}
                                name={"firstName"}
                                label={"First name"}
                                rules={[{ required: true, message: 'Fill in your first name.' }]}
                            >
                                <Input  disabled={props.subscriber?.firstName ? true:false} placeholder={"First name"} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                style={{ color: 'black' }}
                                name={"lastName"}
                                label={"Last name"}
                                rules={[{ required: true, message: 'Fill in your last name.' }]}
                            >
                                <Input  disabled={props.subscriber?.lastName ? true:false} placeholder={"Last name"} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Input.Group>
                <Input.Group size="large">
                    <Form.Item
                        style={{ color: 'black' }}
                        name={"businessName"}
                        label={"Business (optional)"}
                    >
                        <Input  disabled={props.subscriber?.businessName ? true:false} placeholder={"Business (optional)"} />
                    </Form.Item>
                </Input.Group>
                <Input.Group size="large">
                    <Form.Item
                        style={{ color: 'black' }}
                        name={"addressOne"}
                        label={"Address Line 1"}
                        rules={[
                            {
                                required: true,
                                message: 'Fill in your address.'
                            }
                        ]}
                    >
                        <Input  disabled={props.subscriber?.addressOne ? true:false} placeholder={"Address line one"} />
                    </Form.Item>
                </Input.Group>
                <Input.Group size="large">
                    <Form.Item
                        style={{ color: 'black' }}
                        name={"addressTwo"}
                        label={"Address line 2"}
                    >
                        <Input  placeholder={"Address line two"} />
                    </Form.Item>
                </Input.Group>
                <Input.Group size="large">
                    <Row gutter={8}>
                        <Col lg={8} md={24} sm={24} xs={24}>
                            <Form.Item
                                style={{ color: 'black' }}
                                label="City"
                                name="city"
                                rules={[
                                    { required: true, message: 'Enter your city.' }
                                ]}
                            >
                                <Input  disabled={props.subscriber?.city ? true:false} placeholder={"City"} />
                            </Form.Item>
                        </Col>
                        <Col lg={8} md={24} sm={24} xs={24}>
                            <Form.Item
                                style={{ color: 'black' }}
                                label="State"
                                name="state"
                                rules={[
                                    { required: true, message: 'Enter your state.' }
                                ]}
                            >
                                <Select  disabled={props.subscriber?.state ? true:false} placeholder="State">
                                    <Option value="AL">Alabama</Option>
                                    <Option value="AK">Alaska</Option>
                                    <Option value="AZ">Arizona</Option>
                                    <Option value="AR">Arkansas</Option>
                                    <Option value="CA">California</Option>
                                    <Option value="CO">Colorado</Option>
                                    <Option value="CT">Connecticut</Option>
                                    <Option value="DE">Delaware</Option>
                                    <Option value="DC">District Of Columbia</Option>
                                    <Option value="FL">Florida</Option>
                                    <Option value="GA">Georgia</Option>
                                    <Option value="HI">Hawaii</Option>
                                    <Option value="ID">Idaho</Option>
                                    <Option value="IL">Illinois</Option>
                                    <Option value="IN">Indiana</Option>
                                    <Option value="IA">Iowa</Option>
                                    <Option value="KS">Kansas</Option>
                                    <Option value="KY">Kentucky</Option>
                                    <Option value="LA">Louisiana</Option>
                                    <Option value="ME">Maine</Option>
                                    <Option value="MD">Maryland</Option>
                                    <Option value="MA">Massachusetts</Option>
                                    <Option value="MI">Michigan</Option>
                                    <Option value="MN">Minnesota</Option>
                                    <Option value="MS">Mississippi</Option>
                                    <Option value="MO">Missouri</Option>
                                    <Option value="MT">Montana</Option>
                                    <Option value="NE">Nebraska</Option>
                                    <Option value="NV">Nevada</Option>
                                    <Option value="NH">New Hampshire</Option>
                                    <Option value="NJ">New Jersey</Option>
                                    <Option value="NM">New Mexico</Option>
                                    <Option value="NY">New York</Option>
                                    <Option value="NC">North Carolina</Option>
                                    <Option value="ND">North Dakota</Option>
                                    <Option value="OH">Ohio</Option>
                                    <Option value="OK">Oklahoma</Option>
                                    <Option value="OR">Oregon</Option>
                                    <Option value="PA">Pennsylvania</Option>
                                    <Option value="RI">Rhode Island</Option>
                                    <Option value="SC">South Carolina</Option>
                                    <Option value="SD">South Dakota</Option>
                                    <Option value="TN">Tennessee</Option>
                                    <Option value="TX">Texas</Option>
                                    <Option value="UT">Utah</Option>
                                    <Option value="VT">Vermont</Option>
                                    <Option value="VA">Virginia</Option>
                                    <Option value="WA">Washington</Option>
                                    <Option value="WV">West Virginia</Option>
                                    <Option value="WI">Wisconsin</Option>
                                    <Option value="WY">Wyoming</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col lg={8} md={24} sm={24} xs={24}>
                            <Form.Item
                                style={{ color: 'black' }}
                                label="Zip"
                                name="zipCode"
                                rules={[
                                    { required: true, message: 'Enter your zip code.' }
                                ]}
                            >
                                <Input disabled={props.subscriber?.zipCode ? true:false}  placeholder={"Zip code"} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Input.Group>
                <h3>Billing Info</h3>
                <p>(Please note: You won’t be charged now, you are only charged when you place an order)</p>
                <Input.Group size={"large"}>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                style={{ color: 'black' }}
                                label={"Credit or debit card"}
                                name={"card-element"}
                            // required
                            >
                                <CardElement
                                    id="card-element"
                                    options={CARD_ELEMENT_OPTIONS}
                                    className={"ant-input"}
                                    onChange={handleChange}
                                />
                                <div style={{ color: "#ff4d4f" }} role="alert">{error}</div>
                            </Form.Item>
                        </Col>
                    </Row>
                </Input.Group>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey="6LcYyygaAAAAAFz0Tw3z0E9ai4VuDpXX4Z0S1Dj4"
                    onChange={captchaChange}
                />
                <Form.Item
                    style={{ color: 'black' }}>
                    <Button
                        loading={submitting}
                        htmlType={"submit"}
                        block
                        type={"primary"}
                        size={"large"}
                    >
                        Sign Up
                </Button>
                </Form.Item>
                <div style={{ textAlign: 'center' }}>
                    {props.ageWarning && <p>You must be 21 or older to signup.</p>}
                    <p>You are subscribing to receive promotional text messages (MMS {"&"} SMS).</p>
                    <p>Message {"&"} data rates may apply.</p>
                </div>
            </Form>
    )
}
